import { create } from 'zustand';

export const useFlowStore = create((set, get) => ({
  // Flow metadata
  flowName: 'Untitled Flow',
  flowId: null,

  // MQTT connection
  mqttConnected: false,
  mqttConfig: {
    host: '',
    port: 1883,
    username: '',
    password: '',
  },

  // Execution state
  isExecuting: false,

  // Actions
  setFlowName: (name) => set({ flowName: name }),
  setFlowId: (id) => set({ flowId: id }),
  setMqttConnected: (connected) => set({ mqttConnected: connected }),
  setMqttConfig: (config) => set({ mqttConfig: { ...get().mqttConfig, ...config } }),
  setIsExecuting: (executing) => set({ isExecuting: executing }),

  // Node update helper (used by ConfigPanel)
  updateNode: (nodeId, data) => {
    // This will be handled by React Flow's state
    // The ConfigPanel calls this but the actual update happens in FlowEditor
  },

  deleteNode: (nodeId) => {
    // This will be handled by React Flow's state
  },

  // Export flow
  exportFlowJSON: (nodes, edges) => {
    const state = get();
    return {
      name: state.flowName,
      nodes: nodes.map((node) => ({
        node_id: node.id,
        type: node.data?.nodeType || node.type,
        position: node.position,
        config: node.data,
        outputs: edges
          .filter((e) => e.source === node.id)
          .map((e) => e.target),
      })),
      edges,
      mqtt_config: state.mqttConfig,
    };
  },
}));
